import { Fragment } from "react/jsx-runtime";
import { Routes, Route } from "react-router-dom";
import Landing from "pages/Landing";

export const App = () => (
  <Fragment>
    <Routes>
      <Route path="/" element={<Landing />} />
    </Routes>
  </Fragment>
);
